document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".interactive-accordion-module");
  accordions.forEach(accordion => {
    const mediaElements = accordion.querySelectorAll(".accordion-image img, .accordion-image video, .accordion-image iframe");
    const imagePlaceholder = accordion.querySelector(".image-placeholder")
    let minAspectRatio = Infinity;
    mediaElements.forEach(media => {
      let ratio;
      if (media.tagName.toLowerCase() === "img") {
        ratio = media.naturalWidth / media.naturalHeight;
      } else if (
        media.tagName.toLowerCase() === "video") {
        media.addEventListener("loadedmetadata", () => {
          ratio = media.videoWidth / media.videoHeight;
        });
      } else if (media.tagName.toLowerCase() === "iframe") {
        ratio = 1.777777;
      }
      if (ratio) {
        if (ratio < minAspectRatio) {
          minAspectRatio = ratio;
        }
      }
    });
    if (isFinite(minAspectRatio)) {
      imagePlaceholder.style.aspectRatio = minAspectRatio;
    }
  });
});
